import { updateAITrainingEntry } from './updateAITraining';
import fetchAIPromptHistory from './fetchAIPromptHistory';

interface AITraining {
  id: string;
  orgID: string;
  service: string;
  name: string;
  description?: string;
  prompt: string;
  revision: number;
  status?: string;
  users?: string[];
  public?: boolean;
  createdBy?: string;
  lastUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export async function promoteToProduction(
  promptId: string,
  service: 'recorder' | 'askRecorder' | 'askPaiv'
): Promise<void> {
  try {
    // @ts-ignore
    const { orgID } = global.me;

    // Get all prompts for this service to find current production prompt
    const allPrompts = await fetchAIPromptHistory(orgID, service);

    // Find current production prompt and demote it to draft
    const currentProduction = allPrompts.find(
      (prompt: AITraining) => prompt.status === 'production'
    );
    if (currentProduction) {
      await updateAITrainingEntry({
        id: currentProduction.id,
        status: 'draft',
      });
      console.log(
        `Demoted previous production prompt ${currentProduction.id} to draft`
      );
    }

    // Promote the specified prompt to production
    await updateAITrainingEntry({
      id: promptId,
      status: 'production',
    });

    console.log(
      `Successfully promoted prompt ${promptId} to production for ${service}`
    );
  } catch (error) {
    console.error('Error promoting prompt to production:', error);
    throw error;
  }
}
